import React from 'react'
import Header from 'components/Header'
import { Box } from '@mui/material'

const Products = () => {
    return (
        <Box
            padding={2}>
            <Header title='Products' />
        </Box>
    )
}

export default Products